// Rules about a pretty preview row that more than one screen needs.

// Where the row's canvas is opened: its own address, or the canvas service's default one
// for rows saved before the address was stored.
export const prettyPreviewCanvasUrl = (preview) =>
  preview.canvas_url || `https://canvas.cockpit3d.com/canvas/${preview.canvas_id}`;

// Any preview — agent-made or self-served — may have its canvas changed until an order
// is created from it; from then on the order is the record. The back end enforces the
// same rule.
export const isPrettyPreviewCanvasEditable = (preview) => !preview.order_id;
